import request from '@/utils/request'

export default {
  /**
   * 获取操作记录
   * @param params
   */
  getOpRecords(params) {
    return request.get('/op-records/list/action-records', { params })
  }
}
